<template>
  <IconGeneric
    :iconUrl="require('../../assets/wheat.svg')"
    topText="Gluten"
    bottomText="free"
    :showWithout="true"
  ></IconGeneric>
</template>
<script>
  
import IconGeneric from './IconGeneric.vue';

export default {
  name: "IconSansGluten",
  setup() {},
  components: {
    IconGeneric,
  },
};
</script>

<style lang="scss">
  
</style>